var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 pa-0 mw-100"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('header-big',{attrs:{"title":_vm.$t('HomePage.header.summary')}})],1)],1),_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c('workflow-summary',{attrs:{"files":_vm.files,"revoked":_vm.revoked}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }